import { render, staticRenderFns } from "./LessonText.vue?vue&type=template&id=8120c55e&scoped=true&"
import script from "./LessonText.vue?vue&type=script&lang=js&"
export * from "./LessonText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8120c55e",
  null
  
)

export default component.exports